import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { SupplierContact } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SupplierContactService extends TmsWebBaseEditCreateService<SupplierContact, SupplierContact> {
  constructor() {
    super('SupplierContact', $localize`Supplier Contact`);
  }

  getForSupplier(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForSupplier/${id}`);
  }

  getSupplierContactsForSupplier(id: string): Observable<SupplierContact[]> {
    return this.httpService.get<SupplierContact[]>(`${this.apiUrl}/Supplier/${id}`);
  }
}
